import { socketInstance } from "../socket/socket";
import { Message } from "../types/MessageListType";
import { socketQuery } from "./socketQueries";

export type GetDifferenceParams = {
  chat_id: number;
  after_message_id: number;
  limit?: number;
};

export type GetDifferenceRes = {
  chat_id: number;
  after_message_id: number;
  pts: number;
  chat_tip_message_id: number | null;
  has_more_newer: boolean;
  messages: Message[];
  deleted_message_ids: number[];
  error?: string;
};

export async function fetchChatDifference(
  params: GetDifferenceParams,
): Promise<GetDifferenceRes> {
  return (await socketQuery(
    socketInstance(),
    "get_difference",
    {
      limit: 40,
      ...params,
      pts: params.after_message_id,
    },
    "get_difference",
  )) as GetDifferenceRes;
}

/**
 * Catch-up loop after reconnect: apply pages until tip.
 * Returns final pts (chat tip).
 */
export async function catchUpChatDifference(opts: {
  chat_id: number;
  after_message_id: number;
  onPage: (page: GetDifferenceRes) => void;
  maxSteps?: number;
}): Promise<number> {
  let cursor = opts.after_message_id;
  let steps = 0;
  const maxSteps = opts.maxSteps ?? 30;
  let lastPts = cursor;

  while (steps < maxSteps) {
    const page = await fetchChatDifference({
      chat_id: opts.chat_id,
      after_message_id: cursor,
      limit: 40,
    });
    if (page?.error) break;
    opts.onPage(page);
    lastPts = Number(page.pts) || lastPts;
    if (!page.has_more_newer || !page.messages?.length) break;
    const ids = page.messages
      .map((m) => Number(m.message_id))
      .filter((n) => n > 0);
    if (!ids.length) break;
    cursor = Math.max(...ids);
    steps += 1;
  }
  return lastPts;
}
